// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"84bfbe3a","12":"cfdd2e48","129":"16ba8362","358":"25df0bec","372":"a16ea874","528":"654dc30e","698":"c35a233e","723":"c2c263f2","758":"004051c8","895":"3126e785","906":"b841b5c8","919":"c46dd494","973":"306112ca"}[chunkId] + ".chunk.js";
};